import { croodles } from '@dicebear/collection';
import { createAvatar } from '@dicebear/core';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import React from 'react';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

const parseDateStringTime = timeStamp => {
  const strTime = new Date(timeStamp);
  const currentTime = new Date();

  const weekDays = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
  const months = [
    'Gen',
    'Feb',
    'Mar',
    'Apr',
    'Mag',
    'Giu',
    'Lug',
    'Ago',
    'Set',
    'Ott',
    'Nov',
    'Dic'
  ];

  const timeDiff = Math.floor((currentTime - strTime) / 1000);

  if (timeDiff < 60) {
    return 'Adesso';
  } else if (timeDiff < 3600) {
    const minDiff = Math.floor(timeDiff / 60);
    return minDiff + ' min' + (minDiff !== 1 ? 'uti fa' : 'uto fa');
  } else if (timeDiff < 86400) {
    const hourDiff = Math.floor(timeDiff / 3600);
    return hourDiff + ' or' + (hourDiff !== 1 ? 'e fa' : 'a fa');
  } else if (strTime.toDateString() === currentTime.toDateString()) {
    return (
      strTime.getHours() +
      ':' +
      strTime.getMinutes().toString().padStart(2, '0')
    );
  } else if (strTime.getDate() === currentTime.getDate() - 1) {
    return (
      'Ieri alle ' +
      strTime.getHours() +
      ':' +
      strTime.getMinutes().toString().padStart(2, '0')
    );
  } else if (strTime.getDay() >= currentTime.getDay() - 7) {
    return (
      weekDays[strTime.getDay()] +
      ' alle ' +
      strTime.getHours() +
      ':' +
      strTime.getMinutes().toString().padStart(2, '0')
    );
  } else {
    return (
      strTime.getDate() +
      ' ' +
      months[strTime.getMonth()] +
      (strTime.getFullYear() !== currentTime.getFullYear()
        ? ' ' + strTime.getFullYear()
        : '') +
      ' alle ' +
      strTime.getHours() +
      ':' +
      strTime.getMinutes().toString().padStart(2, '0')
    );
  }
};

const FeedObject = ({ name, points, quantity, player, createdAt }) => {
  const avatar = createAvatar(croodles, {
    seed: player,
    size: 100
  }).toDataUriSync();

  const displayScore = number => {
    if (number > 0) return '+' + number;
    return number;
  };

  return (
    <div
      className={classNames('notification', 'mb-1', 'ps-2', {
        'border-bonus': points > 0,
        'border-malus': points <= 0
      })}
    >
      <Col>
        <Flex alignItems="center">
          <div className="notification-avatar me-3">
            <div className="avatar avatar-3xl">
              <img className="rounded-circle " src={avatar} alt="" />
            </div>
          </div>
          <div className="notification-body mb-0 fs-9 fw-normal">
            <p className="mb-0">
              <strong>{player} </strong>
              <br className="d-md-none" />
              ha ricevuto il {points > 0 ? 'BONUS' : 'MALUS'}
            </p>
            <p className="mb-0">
              <strong>
                {name} ×{quantity}
              </strong>
            </p>
            <span className="notification-time">
              {parseDateStringTime(createdAt)}
            </span>
          </div>
        </Flex>
      </Col>
      <Col md={'auto'} className="d-flex align-items-center">
        <h5 className="mb-0 fw-semibold">
          <span className={points > 0 ? 'text-success' : 'text-danger'}>
            {displayScore(points * quantity)}
          </span>
        </h5>
      </Col>
    </div>
  );
};

FeedObject.propTypes = {
  name: PropTypes.string.isRequired,
  points: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  player: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired
};

export default FeedObject;
